import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { Grid, Typography } from "@mui/material";
import { shouldForwardProp } from "../utils";

type PpContainer = {
  $darkBackground: boolean;
};

export const DifferencesContainer = styled("div", {
  shouldForwardProp,
})<PpContainer>`
  ${({ $darkBackground, theme }): SerializedStyles => css`
    ${$darkBackground &&
    css`
      background-color: ${theme.palette.site.shadowHeader.dark};
    `};
    padding-top: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(8)};
    ${theme.breakpoints.up("md")} {
      padding-top: ${theme.spacing(12)};
      padding-bottom: ${theme.spacing(12)};
    }
  `}
`;

export const ToggleBtnGroupContainer = styled(Grid)`
  ${({ theme }): SerializedStyles => css`
    margin-top: ${theme.spacing(3)};
    margin-bottom: ${theme.spacing(1)};
    max-width: 450px !important;
    width: 100%;
    .MuiToggleButtonGroup-root {
      width: 100%;
      > button {
        flex: 1;
      }
    }
    ${theme.breakpoints.up("md")} {
      margin: ${theme.spacing(3)} auto 0;
      max-width: none !important;
      width: 650px !important;
    }
  `}
`;

export const ItemsContainer = styled(Grid)`
  ${({ theme }): SerializedStyles => css`
    margin-top: ${theme.spacing(4)};
    ${theme.breakpoints.down("md")} {
      margin-top: ${theme.spacing(3)};
      max-width: 380px;
    }
  `};
`;

export const ItemContainer = styled(Grid)`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.toggleInAnimation({ duration: 300 })};
  `}
`;

export const Icon = styled(Grid)`
  ${({ theme }): SerializedStyles => css`
    display: inline-flex;
    ${theme.cssMixins.diffIconStyle};
  `}
`;

export const ItemTitle = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    text-align: left;
    ${theme.breakpoints.up("md")} {
      text-align: center;
    }
  `}
`;

export const ItemDescription = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.lineClamp({ lines: 3 })};
    text-align: left;
    ${theme.breakpoints.up("md")} {
      text-align: center;
    }
  `}
`;
